import * as React from "react";
import {CSSProperties, MouseEventHandler} from "react";

export class FontAwesomeIcon extends React.Component<FontAwesomeIconProps, FontAwesomeIconState> {
    static defaultProps: Partial<FontAwesomeIconProps> = {
        title:''
    };

    constructor(props: FontAwesomeIconProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <svg onClick={e=>this.props.onClick&&this.props.onClick(e)} fill={'currentColor'} className={this.props.className} style={{height: '1em', ...this.props.style}} viewBox={this.GetViewBox()}>
                {this.props.title!=''?<title>{this.props.title}</title>:null}
                <path d={this.GetSVGPath()}/>
            </svg>
        )
    }

    private GetViewBox():any {
        if(this.props.icon==null)
            return '';
        let width=this.props.icon.icon[0];
        let height=this.props.icon.icon[1];
        return `0 0 ${width} ${height}`;
    }

    private GetSVGPath() {
        if(this.props.icon==null)
            return null;
        return this.props.icon.icon[4];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FontAwesomeIconProps {
    icon:any;
    title:string;
    className:string;
    style:CSSProperties;
    onClick:(e:React.MouseEvent)=>void;
}

interface FontAwesomeIconState {

}

//#endregion "My Region"